(function ($) {
    "use strict";
    $(function () {

        //Default modal
        let modal = localize.modalJson;

        let isActive = modal.isActive;
        let html = modal.html;
        let delay = modal.delay;
        let onlyOnce = modal.onlyOnce;
        let open = modal.opens;
        let pages = modal.pages;
        let showTo = modal.showTo;
        let width = modal.width;

        if (isActive === false) {
            return;
        }

        let cookieExpires = '';

        if (open == 0) {
            cookieExpires = 0;
        } else {
            cookieExpires = open % 2
        }

        bioEp.init({
            html: html,
            showOnDelay: delay,
            showOncePerSession: onlyOnce,
            delay: delay,
            css: '#bio_ep {width:' + width + 'px;',
            cookieExp: cookieExpires
        });

        //Presentation form modal
        $("#acceptCookieModal").iziModal();

    });
})(jQuery);